import React, { useEffect, useState, useRef, useMemo } from "react";
import { Row, Col } from "react-flexbox-grid";
import {
  Button,
  SelectField,
  TextField,
  Checkbox,
  DialogContainer,
} from "react-md";
import "../styles/createAccountStyles.css";
import FontIcon from "react-md/lib/FontIcons";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import AssignUtils from "../services/AssignUtils";
import EventService from "../../../../../service/event/EventService";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import GlobalSkeletonLoader from "../../../../../components/common/GlobalSkeletonLoader";
import NoRecordsIcon from "../../../../../assets/icons/no-records.png";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Modal,
  Select,
  IconButton,
} from "@material-ui/core";
import moment from "moment";
import { FaWallet } from "react-icons/fa";
import NavigoDashboardUtils from "../../navigo-module/services/NavigoDashboardUtils";
import checkIcon from "../../../../../assets/images/green_check_icon.svg";
import transactionFilter from "../../../../../assets/icons/transactionFilter.svg";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import CloseIcon from "@material-ui/icons/Close";

export const AssignedPlansOnPid = (props) => {
  const location = useLocation();
  const history = useHistory();
  const [pid, setPid] = useState(null);
  const [patientDetails, setPatientDetails] = useState(null);
  const [plansOnPid, setPlansOnPid] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);
  const [changingStatus, setChangingStatus] = useState(false);
  const [openStatusConfirmDialog, setOpenStatusConfirmDialog] = useState(false);
  const [planForStatusChange, setPlanForStatusChange] = useState(null);
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [subLimitData, setSubLimitData] = useState({});
  const [categoryData, setCategoryData] = useState([]);
  const [walletId, setWalletId] = useState(0);
  const [walletTrans, setWalletTrans] = useState({});
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const TxnpageSize = 30;
  const [txnCurrentPage, setTxnCurrentPage] = useState(1);
  const [txnTotalPages, setTxnTotalPages] = useState(1);
  const [blockedAmount, setBlockedAmount] = useState([]);
  const [totalBlocked, setTotalBlocked] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [debitModal, setDebitModal] = useState(false);
  const [refundModal, setRefundModal] = useState(false);
  const [tab, setTab] = useState(0);
  const [comment, setComment] = useState("");
  const [totalModes, setTotalModes] = useState([]);
  const [planSelected, setPlanSelected] = useState(null);
  const [serviceTypeList, setServiceTypeList] = useState([]);
  const [allPlans, setAllPlans] = useState([]);
  const [amount, setAmount] = useState("");
  const [serviceCategory, setServiceCategory] = useState(0);
  const [serviceId, setServiceId] = useState("");
  const [success, setSuccess] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize] = useState(30);
  const [loading, setLoading] = useState(false);
  const [selectedWalletId, setSelectedWallet] = useState(0);
  const assignUtils = new AssignUtils();
  const navigoDashboardUtils = new NavigoDashboardUtils();

  useEffect(() => {
    const path = history.location.pathname;
    const match = path.match(/\/assigned-plans\/(\d+)/);

    const id = match ? match[1] : null;
    if (id != null) {
      setPid(id);
      getPatientDetails(id);
      fetchPlansOnPatientId(id);
    }
  }, []);

  const getPatientDetails = (id) => {
    const onResponse = (res) => {
      setPatientDetails(res);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };

    assignUtils.fetchPatientId(id, onResponse, onError);
  };

  const handleOpen = (item) => {
    console.log("item is ", item);
    setSelectedItem(item);
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };
  const fetchPlansOnPatientId = (id) => {
    setLoadingTable(true);
    const onResponse = (res) => {
      setLoadingTable(false);
      setPlansOnPid(res == null || res.length == 0 ? [] : res);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoadingTable(false);
    };

    assignUtils.getPlansForPid2(id, onResponse, onError);
  };
  const setPlanStatusInactive = (planId) => {
    let body = {
      patientId: Number(pid),
      planIds: [planId],
      markOnlySingleStatus: true,
    };

    setChangingStatus(true);
    const onResponse = (res) => {
      exitDialog();
      fetchPlansOnPatientId(pid);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      exitDialog();
    };

    assignUtils.setPlanStatusInactive(body, onResponse, onError);
  };
  const confirmDialog = (plan) => {
    setPlanForStatusChange(plan);
    setOpenStatusConfirmDialog(true);
  };
  const exitDialog = () => {
    setChangingStatus(false);
    setOpenStatusConfirmDialog(false);
    setPlanForStatusChange(null);
  };

  const getWalletData = (id, page = 1) => {
    const body = {
      walletId: id,
      range: "all",
      pageNum: page,
      pageSize: TxnpageSize,
    };
    assignUtils.getWalletData(
      body,
      (res) => {
        setWalletTrans(res.transactions || []);
        setTxnTotalPages(Math.ceil((res.totalCount || 0) / TxnpageSize) || 1);
        setTxnCurrentPage(page);
        setShowWalletModal(true);
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };

  const getPastDate = (monthsAgo) => {
    const d = new Date();
    d.setMonth(d.getMonth() - monthsAgo);
    return d;
  };

  const filteredTransactionsMemo = useMemo(() => {
    const list = Array.isArray(walletTrans) ? walletTrans : [];
    return list.filter((t) => {
      const dt = new Date(t.createdAt);
      if (Number.isNaN(dt.getTime())) return false;

      switch (selectedFilter) {
        case "3months":
          return dt >= getPastDate(3);
        case "6months":
          return dt >= getPastDate(6);
        case "1year":
          return dt >= getPastDate(12);
        default:
          return true;
      }
    });
  }, [walletTrans, selectedFilter]);

  useEffect(() => {
    setFilteredTransactions(filteredTransactionsMemo);
  }, [filteredTransactionsMemo]);

  // 🔹 Handle Page Change
  const handleTxnPageChange = (page) => {
    if (page < 1 || page > txnTotalPages) return;
    getWalletData(selectedWalletId, page);
  };

  const getBlockedAmount = (walletId, pageNo = 1) => {
    setLoading(true);

    const body = { walletId, range: "", pageNo, pageSize };

    assignUtils.getBlockedAmount(
      patientDetails.id,
      body,
      (res) => {
        setBlockedAmount(res.entries || []);
        if (res.totalCount && res.totalCount > 0) {
          const pages = Math.ceil(res.totalCount / pageSize);
          setTotalPages(pages);
        } else {
          setTotalPages(1);
        }

        setLoading(false);
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
        setLoading(false);
      },
    );
  };

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    setCurrentPage(newPage);
    getBlockedAmount(selectedWalletId, newPage);
  };

  const handleWalletClick = (planId, patientId, aid) => {
    assignUtils.getWalletAmount(
      planId,
      patientId,
      aid,
      (res) => {
        setSubLimitData(res);
        setTotalBlocked(res.wallet.blockedAmount);
        setCategoryData(res.sublimit);
        getWalletData(res.wallet.id);
        getBlockedAmount(res.wallet.id);
        setSelectedWallet(res.wallet.id);
        setWalletId(res.wallet.id);
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };

  useEffect(() => {
    if (planSelected != null) {
      const selectedPlan = allPlans.find(
        (plan) => plan.planId === planSelected?.id,
      );
      console.log("selected plan", selectedPlan, allPlans);
      if (selectedPlan) {
        let types = totalModes
          .filter((e) => {
            if (selectedPlan.bookConsultation && e.id === 1) {
              return true;
            } else if (selectedPlan.bookHealthCheckup && e.id === 2) {
              return true;
            } else if (selectedPlan.bookVaccination && e.id === 3) {
              return true;
            }
            return false;
          })
          .map((e) => ({
            serviceTypeId: e.id,
            serviceTypeName: e.name,
          }));

        setServiceTypeList(types);
      }
    }
  }, [planSelected, allPlans, totalModes]);

  const processMoney = (id) => {
    const body = {
      transactionType: id,
      comment: comment,
      amount: amount,
      serviceCategoryId: serviceCategory ? parseInt(serviceCategory) : 0,
      serviceId: serviceId ? parseInt(serviceId) : 0,
    };
    navigoDashboardUtils.processMoney(
      body,
      walletId,
      (res) => {
        console.log("successfull", res);
        setSuccess(true);
        resetForm();
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };
  const resetForm = () => {
    setWalletId("");
    setAmount("");
    setServiceCategory("");
    setServiceId("");
    setComment("");
    setSelectedFilter("all");
    setTab(0);
  };

  return (
    <div className="account-module-page-padding">
      {patientDetails == null ? (
        <></>
      ) : (
        <>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className="account-module-view">
                <div className="account-module-heading-with-back-button">
                  <div
                    className="account-module-back-btn"
                    onClick={() => {
                      if (location.state?.from === "allow_back") {
                        history.go(-1);
                      } else {
                        history.push(`/patients`);
                      }
                    }}
                  >
                    <FontIcon style={{ fontSize: "36px" }}>arrow_back</FontIcon>
                  </div>
                  <h1>{`Assigned plans`}</h1>
                </div>
              </div>
            </Col>
          </Row>
          <br />
          <br />
          <div className="account-module-grey-heading">Patient details</div>
          <br />
          <div className="account-module-create-service-container">
            <Row>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="account-module-create-service-field-container">
                  <div className="account-module-label">{`Patient ID`}</div>
                  <div>
                    <TextField
                      value={patientDetails?.id}
                      lineDirection="left"
                      disabled
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div style={{ height: "20px" }}></div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="account-module-create-service-field-container">
                  <div className="account-module-label">{`Patient name`}</div>
                  <div>
                    <TextField
                      value={`${patientDetails?.firstName} ${patientDetails?.lastName}`}
                      lineDirection="left"
                      disabled
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <br />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <h3>Assigned plans</h3>
            </div>
            <div>
              <Button
                raised
                className={"account-module-button-save-enabled"}
                style={{ marginRight: "10px" }}
                onClick={() => {
                  history.push(`/assign-account/${pid}`, {
                    from: "allow_back",
                  });
                }}
              >
                {"Add account"}
              </Button>
              <Button
                raised
                className={"account-module-button-save-enabled"}
                onClick={() => {
                  history.push(`/assign-plan/${pid}`);
                }}
              >
                {"Add plan"}
              </Button>
            </div>
          </div>
          <br />
          <div className="account-module-table-container">
            <div className="table">
              <div className="table-row1 table-header1">
                <div className="table-cell" style={{ width: "10%" }}>
                  Account ID
                </div>
                <div className="table-cell" style={{ width: "15%" }}>
                  Account name
                </div>
                <div className="table-cell" style={{ width: "15%" }}>
                  Plan ID
                </div>
                <div className="table-cell" style={{ width: "15%" }}>
                  Plan name
                </div>
                <div className="table-cell" style={{ width: "15%" }}>
                  Plan start date
                </div>
                <div className="table-cell" style={{ width: "15%" }}>
                  Plan end date
                </div>
                <div className="table-cell" style={{ width: "15%" }}>
                  Wallet
                </div>
                <div className="table-cell" style={{ width: "15%" }}>
                  Plan status
                </div>
              </div>
              {loadingTable ? (
                <GlobalSkeletonLoader />
              ) : plansOnPid.length == 0 ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "20px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginBottom: "20px" }}>
                      No records to show
                    </div>
                    <img src={NoRecordsIcon} width={50} height={62} />
                  </div>
                </div>
              ) : (
                plansOnPid.map((plan) => {
                  return (
                    <div className="table-row1">
                      <div className="table-cell" style={{ width: "10%" }}>
                        {plan.planDetails.accountCode}
                      </div>
                      <div className="table-cell" style={{ width: "15%" }}>
                        {plan.planDetails.accountName}
                      </div>
                      <div className="table-cell" style={{ width: "15%" }}>
                        {plan.patientPlanInfo.planId}
                      </div>
                      <div className="table-cell" style={{ width: "15%" }}>
                        {plan.planDetails.basicDetails.name}
                      </div>
                      <div className="table-cell" style={{ width: "15%" }}>
                        {moment
                          .utc(plan.patientPlanInfo.planStartDate)
                          .isSame(moment.utc("0001-01-01T00:00:00Z"))
                          ? "NA"
                          : moment
                              .utc(plan.patientPlanInfo.planStartDate)
                              .format("DD MMM YYYY")}
                      </div>
                      <div className="table-cell" style={{ width: "15%" }}>
                        {moment
                          .utc(plan.patientPlanInfo.planEndDate)
                          .isSame(moment.utc("0001-01-01T00:00:00Z"))
                          ? "NA"
                          : moment
                              .utc(plan.patientPlanInfo.planEndDate)
                              .format("DD MMM YYYY")}
                      </div>
                      <div
                        className="table-cell"
                        style={{
                          width: "15%",
                          cursor: plan.planDetails.walletDetails
                            .isWalletIncluded
                            ? "pointer"
                            : "default",
                          textDecoration: plan.planDetails.walletDetails
                            .isWalletIncluded
                            ? "underline"
                            : "none",
                          color: plan.planDetails.walletDetails.isWalletIncluded
                            ? "inherit"
                            : "#888",
                        }}
                        onClick={
                          plan.planDetails.walletDetails.isWalletIncluded
                            ? () => {
                                handleWalletClick(
                                  plan.patientPlanInfo.planId,
                                  patientDetails.id,
                                  plan.patientPlanInfo.planAssignmentId,
                                );
                                setPlanSelected(plan.planDetails);
                              }
                            : undefined
                        }
                      >
                        {plan.planDetails.walletDetails.isWalletIncluded
                          ? plan.planDetails.walletDetails.isUnlimitedWallet
                            ? "Unlimited"
                            : plan.planDetails.walletDetails.walletLimit
                          : "NA"}
                      </div>

                      <div
                        className="table-cell status-cell"
                        style={{ width: "15%" }}
                      >
                        <Select
                          value={
                            plan.patientPlanInfo.currentPlanStatus == 1
                              ? "Active"
                              : plan.patientPlanInfo.currentPlanStatus == 2
                                ? "Inactive"
                                : plan.patientPlanInfo.currentPlanStatus == 3
                                  ? "Upcoming"
                                  : plan.patientPlanInfo.currentPlanStatus == 4
                                    ? "Expired"
                                    : "-"
                          }
                          onChange={(e) => {
                            if (e.target.value === "Inactive") {
                              confirmDialog(plan);
                            }
                          }}
                          disableUnderline
                          disabled={
                            plan.patientPlanInfo.currentPlanStatus == 2 ||
                            plan.patientPlanInfo.currentPlanStatus == 3 ||
                            plan.patientPlanInfo.currentPlanStatus == 4 ||
                            changingStatus
                          }
                          className={
                            plan.patientPlanInfo.currentPlanStatus == 1
                              ? "status-select-active"
                              : plan.patientPlanInfo.currentPlanStatus == 2
                                ? "status-select-inactive"
                                : plan.patientPlanInfo.currentPlanStatus == 3
                                  ? "status-select-upcoming"
                                  : "status-select-expired"
                          }
                        >
                          <MenuItem value="Active" style={{ display: "none" }}>
                            Active
                          </MenuItem>
                          <MenuItem value="Inactive">Inactive</MenuItem>
                          <MenuItem
                            value="Upcoming"
                            style={{ display: "none" }}
                          >
                            Upcoming
                          </MenuItem>
                          <MenuItem value="Expired" style={{ display: "none" }}>
                            Expired
                          </MenuItem>
                        </Select>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </>
      )}
      {openStatusConfirmDialog && (
        <DialogContainer
          id="plan-patient-status-change-confirm-dialog"
          visible={openStatusConfirmDialog}
          focusOnMount={false}
          onHide={() => {
            if (!changingStatus) {
              exitDialog();
            }
          }}
          width="600px"
          autosizeContent
          height="auto"
          style={{ textAlign: "left" }}
          dialogStyle={{ borderRadius: "10px", position: "relative" }}
        >
          <div className="account-module-confirm-diaglog">
            <div>{`Are you sure you want to mark`}</div>
            <div className="account-module-confirm-diaglog-text">
              <div>{`Plan: ${planForStatusChange?.planDetails.basicDetails.name}`}</div>
              <div style={{ fontWeight: "bold" }}>&nbsp;{`inactive`}&nbsp;</div>
              <div>{`for Patient: ${patientDetails?.firstName} ${patientDetails?.lastName}`}</div>
            </div>
            <br />
            <div className="account-module-confirm-diaglog-btn">
              <div className="account-module-buttons-right-alignment">
                <Button
                  raised
                  disabled={changingStatus}
                  className={
                    changingStatus
                      ? "account-module-button-save-disabled"
                      : "account-module-button-save-enabled"
                  }
                  onClick={() => {
                    setPlanStatusInactive(
                      planForStatusChange.patientPlanInfo.planId,
                    );
                  }}
                >
                  {"Confirm"}
                </Button>

                <Button
                  raised
                  disabled={changingStatus}
                  className="account-module-button-cancel"
                  onClick={() => {
                    exitDialog();
                  }}
                >
                  {"Cancel"}
                </Button>
              </div>
            </div>
          </div>
        </DialogContainer>
      )}
      <Dialog
        open={showWalletModal}
        onClose={() => {
          setShowWalletModal(false);
          resetForm();
        }}
        fullWidth
        maxWidth="md"
      >
        <h2 className="wallet-dialog-title">Wallet details</h2>

        <DialogContent>
          {/* Wallet Card */}
          {subLimitData?.wallet && (
            <Box className="wallet-box">
              {/* Header */}
              <div className="wallet-header">
                <div>
                  <p className="wallet-patient-name">
                    {`${patientDetails?.firstName ?? ""} ${
                      patientDetails?.lastName ?? ""
                    }`}
                  </p>
                  <p className="wallet-subtitle">{planSelected.accountName}</p>
                </div>

                <div className="wallet-right">
                  <div className="wallet-title">
                    <FaWallet className="wallet-icon" /> Wallet
                  </div>
                  <p className="wallet-expiry">
                    Valid upto -{" "}
                    {moment
                      .utc(subLimitData.wallet.expiryDate)
                      .format("DD MMM YYYY")}
                  </p>
                </div>
              </div>

              {/* Body */}
              {!planSelected.walletDetails.isUnlimitedWallet && (
                <div className="wallet-body">
                  <div className="wallet-body-box">
                    <div className="wallet-amount-row">
                      <div>
                        <p className="wallet-label">Balance</p>
                        <p className="wallet-amount">
                          ₹{subLimitData.wallet.amount}
                        </p>
                      </div>
                      <div>
                        <p className="wallet-label">Total wallet size</p>
                        <p className="wallet-total">
                          ₹{subLimitData.wallet.total}
                        </p>
                      </div>
                    </div>

                    <div className="wallet-progress-bar">
                      <div
                        className="wallet-progress"
                        style={{
                          "--progress-width": `${
                            (subLimitData.wallet.amount /
                              (subLimitData.wallet.total || 1)) *
                            100
                          }%`,
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </Box>
          )}

          {/* Tabs */}
          <div className="wallet-tabs">
            <div
              className={`wallet-tab ${tab === 0 ? "active" : ""}`}
              onClick={() => setTab(0)}
            >
              Wallet sub-limits
            </div>
            <div
              className={`wallet-tab ${tab === 1 ? "active" : ""}`}
              onClick={() => setTab(1)}
            >
              Wallet transaction history
            </div>
            <div
              className={`wallet-tab ${tab === 2 ? "active" : ""}`}
              onClick={() => setTab(2)}
            >
              Blocked amount
            </div>
          </div>

          {tab === 0 && (
            <Box className="mt-3 wallet-section">
              {subLimitData?.sublimit?.length > 0 ? (
                subLimitData?.sublimit?.map((item, index) => (
                  <div key={index} className="wallet-sublimit-card">
                    <h4 className="wallet-title">{item.name}</h4>

                    <div className="wallet-tags">
                      {item.isCashless && (
                        <span className="wallet-tag orange">Cashless</span>
                      )}
                      {item.isClaim && (
                        <span className="wallet-tag purple">Claim</span>
                      )}
                    </div>
                    <div
                      className={
                        item.status.statusId === 1 &&
                        item.balance?.total === 0 &&
                        item.balance?.available === 0
                          ? ""
                          : `wallet-limit-box ${
                              [2, 3].includes(item.status.statusId)
                                ? "wallet-greyed"
                                : ""
                            }`
                      }
                    >
                      <div className="flex justify-between items-center">
                        <p
                          className={`limit-label ${
                            [2, 3].includes(item.status.statusId) &&
                            !(
                              item.status.statusId === 1 &&
                              item.balance?.total === 0 &&
                              item.balance?.available === 0
                            )
                              ? "status-red"
                              : ""
                          }`}
                        >
                          {item.status.statusId === 1 &&
                          item.balance?.total === 0 &&
                          item.balance?.available === 0
                            ? "*no sublimit exist"
                            : item.status.statusMsg}
                        </p>

                        {item.balance.isFixedAmount && (
                          <span
                            className="wallet-fixed"
                            style={{ marginLeft: "262px" }}
                          >
                            <i className="fa fa-lock"></i> Fixed sublimit
                          </span>
                        )}
                      </div>

                      {!(
                        item.status.statusId === 1 &&
                        item.balance?.total === 0 &&
                        item.balance?.available === 0
                      ) && (
                        <>
                          <div className="limit-row">
                            <p className="available">
                              ₹{item.balance.available}
                              {item.balance.blocked > 0 && (
                                <>
                                  {" "}
                                  <IconButton
                                    onClick={() => handleOpen(item)}
                                    className="info-icon"
                                    size="small"
                                  >
                                    <InfoOutlinedIcon
                                      style={{ color: "#F36B2B" }}
                                    />
                                  </IconButton>
                                  <Modal
                                    open={openModal}
                                    onClose={handleClose}
                                    BackdropProps={{
                                      style: {
                                        backgroundColor: "rgba(0,0,0,0.2)",
                                      },
                                    }}
                                  >
                                    <div className="wallet-info-modal">
                                      <div className="modal-header-wallet">
                                        <h3>{selectedItem.name}</h3>
                                        <IconButton
                                          onClick={handleClose}
                                          size="small"
                                        >
                                          <CloseIcon />
                                        </IconButton>
                                      </div>

                                      {selectedItem && (
                                        <>
                                          <div className="blocked-amount-box">
                                            Blocked amount : ₹
                                            {selectedItem?.balance?.blocked.toFixed(
                                              2,
                                            )}
                                          </div>
                                          <div className="how-it-works">
                                            <h4>How this works?</h4>
                                            <p>
                                              Blocked amount is part of your
                                              wallet balance that’s on hold
                                              until verified.
                                            </p>
                                            <p>
                                              The available limit = Total
                                              sublimit – (Amount spent + Amount
                                              blocked)
                                            </p>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </Modal>
                                </>
                              )}
                            </p>
                            <p className="available">₹{item.balance.total}</p>
                          </div>

                          <div className="wallet-sublimit-bar">
                            <div
                              className="wallet-sublimit-progress"
                              style={{
                                width: `${
                                  (item.balance.available /
                                    (item.balance.total || 1)) *
                                  100
                                }%`,
                              }}
                            />
                          </div>
                        </>
                      )}
                    </div>

                    {(() => {
                      const cashlessPerTxn = item.cashless?.perTransactionlimit;
                      const claimPerTxn = item.claim?.perTransactionlimit;

                      const cashlessCoPay = item.cashless?.coPaylimit;
                      const claimCoPay = item.claim?.coPaylimit;

                      const formatValue = (limit) =>
                        limit.unit === 1
                          ? `${limit.value}%`
                          : `₹${limit.value}`;

                      // Helper to render limits only if enabled
                      const renderLimit = (cashless, claim, label) => {
                        if (!(cashless?.enabled || claim?.enabled)) return null;

                        const cashlessValue = cashless?.enabled
                          ? formatValue(cashless)
                          : null;
                        const claimValue = claim?.enabled
                          ? formatValue(claim)
                          : null;

                        if (cashlessValue && claimValue) {
                          if (cashlessValue === claimValue) {
                            return (
                              <div className="wallet-detail">
                                {label} - {cashlessValue}
                              </div>
                            );
                          } else {
                            return (
                              <div className="wallet-detail">
                                {label} - {cashlessValue} (Cashless),{" "}
                                {claimValue} (Claim)
                              </div>
                            );
                          }
                        }

                        if (cashlessValue) {
                          return (
                            <div className="wallet-detail">
                              {label} - {cashlessValue} (Cashless)
                            </div>
                          );
                        }

                        if (claimValue) {
                          return (
                            <div className="wallet-detail">
                              {label} - {claimValue} (Claim)
                            </div>
                          );
                        }

                        return null;
                      };

                      return (
                        <>
                          {renderLimit(
                            cashlessPerTxn,
                            claimPerTxn,
                            "Per transaction limit",
                          )}
                          {renderLimit(
                            cashlessCoPay,
                            claimCoPay,
                            "Copay by employee",
                          )}
                        </>
                      );
                    })()}
                  </div>
                ))
              ) : (
                <p className="no-data">There is no data for sublimit</p>
              )}
            </Box>
          )}

          {tab === 1 && (
            <Box className="mt-3 wallet-section">
              <div className="filter-container">
                {" "}
                <img
                  src={transactionFilter}
                  alt="Filter"
                  className="filter-icon"
                />{" "}
                <select
                  value={selectedFilter}
                  onChange={(e) => setSelectedFilter(e.target.value)}
                  className="filter-input"
                >
                  {" "}
                  <option value="" disabled>
                    {" "}
                    Select filter{" "}
                  </option>{" "}
                  <option value="all">All transactions</option>{" "}
                  <option value="3months">Last 3 months</option>{" "}
                  <option value="6months">Last 6 months</option>{" "}
                  <option value="1year">Last 1 year</option>{" "}
                </select>{" "}
              </div>
              {totalBlocked != 0 && (
                <div className="blocked-amount-bar">
                  Blocked amount : ₹{totalBlocked?.toFixed(2)}
                </div>
              )}
              {filteredTransactions.length > 0 ? (
                <>
                  {filteredTransactions
                    .sort(
                      (a, b) =>
                        new Date(b.createdAt).getTime() -
                        new Date(a.createdAt).getTime(),
                    )
                    .map((txn, index) => {
                      const currentMonth = moment(txn.createdAt).format(
                        "MMMM YYYY",
                      );
                      const prevMonth =
                        index > 0
                          ? moment(
                              filteredTransactions[index - 1].createdAt,
                            ).format("MMMM YYYY")
                          : null;

                      const showMonthHeader = currentMonth !== prevMonth;

                      return (
                        <React.Fragment key={txn.id}>
                          {showMonthHeader && (
                            <div className="month-divider">
                              <hr className="month-line" />
                              <span className="month-text">{currentMonth}</span>
                              <hr className="month-line" />
                            </div>
                          )}

                          <div className="wallet-transaction-card">
                            <div className="wallet-transaction-info">
                              <p className="wallet-transaction-title">
                                {txn.comment}
                              </p>
                              <p className="wallet-transaction-date">
                                {moment(txn.createdAt).format(
                                  "DD MMM YYYY, hh:mm A",
                                )}
                              </p>
                            </div>

                            <div className="wallet-transaction-right">
                              <p
                                className={`wallet-transaction-amount ${
                                  txn.transactionType === 1
                                    ? "positive"
                                    : "negative"
                                }`}
                              >
                                {txn.transactionType === 1
                                  ? `+₹${txn.amount}`
                                  : `-₹${Math.abs(txn.amount)}`}
                              </p>

                              <div className="wallet-tags">
                                {txn.type === 2 ? (
                                  <span className="wallet-tag purple">
                                    Claim
                                  </span>
                                ) : txn.type === 1 ? (
                                  <span className="wallet-tag orange">
                                    Cashless
                                  </span>
                                ) : txn.type === 3 ? (
                                  <span className="wallet-tag green">
                                    Refund
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    })}

                  {/* ✅ Pagination specific to Transactions */}
                  {txnTotalPages > 1 && (
                    <div className="wallet-pagination">
                      <button
                        className="pagination-arrow"
                        onClick={() => handleTxnPageChange(txnCurrentPage - 1)}
                        disabled={txnCurrentPage === 1}
                      >
                        ←
                      </button>

                      {[...Array(txnTotalPages)].map((_, index) => (
                        <button
                          key={index}
                          className={`pagination-page ${
                            txnCurrentPage === index + 1 ? "active" : ""
                          }`}
                          onClick={() => handleTxnPageChange(index + 1)}
                        >
                          {index + 1}
                        </button>
                      ))}

                      <button
                        className="pagination-arrow"
                        onClick={() => handleTxnPageChange(txnCurrentPage + 1)}
                        disabled={txnCurrentPage === txnTotalPages}
                      >
                        →
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <p className="no-data">
                  There is no transaction on this wallet
                </p>
              )}
            </Box>
          )}

          {tab === 2 && (
            <Box className="mt-3 wallet-section">
              {Array.isArray(blockedAmount) && blockedAmount.length > 0 ? (
                <>
                  {blockedAmount
                    // sort newest first
                    .sort(
                      (a, b) =>
                        new Date(b.createdAt).getTime() -
                        new Date(a.createdAt).getTime(),
                    )
                    .map((txn, index) => {
                      const currentMonth = txn.createdAt
                        ? moment(txn.createdAt).format("MMMM YYYY")
                        : "Unknown";

                      const prevMonth =
                        index > 0 && blockedAmount[index - 1].createdAt
                          ? moment(blockedAmount[index - 1].createdAt).format(
                              "MMMM YYYY",
                            )
                          : null;

                      const showMonthHeader = currentMonth !== prevMonth;

                      return (
                        <React.Fragment key={txn.id}>
                          {showMonthHeader && (
                            <div className="month-divider">
                              <hr className="month-line" />
                              <span className="month-text">{currentMonth}</span>
                              <hr className="month-line" />
                            </div>
                          )}

                          <div className="wallet-transaction-card-blocked">
                            <div className="wallet-transaction-info">
                              <p className="wallet-transaction-title">
                                {txn.comment || "—"}
                              </p>
                              <p className="wallet-transaction-date">
                                {txn.createdAt
                                  ? moment(txn.createdAt).format(
                                      "DD MMM YYYY, hh:mm A",
                                    )
                                  : "—"}
                              </p>
                            </div>

                            <div className="wallet-transaction-right">
                              <p
                                className={`wallet-transaction-amount ${
                                  txn.transactionType === 1
                                    ? "positive"
                                    : "negative"
                                }`}
                              >
                                {txn.transactionType === 1
                                  ? `+₹${txn.amount}`
                                  : `-₹${Math.abs(txn.amount)}`}
                              </p>

                              <div className="wallet-tags">
                                {txn.type === 2 ? (
                                  <span className="wallet-tag purple">
                                    Claim
                                  </span>
                                ) : (
                                  <span className="wallet-tag orange">
                                    Cashless
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    })}

                  {totalPages > 1 && (
                    <div className="wallet-pagination">
                      <button
                        className="pagination-arrow"
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        ←
                      </button>

                      {[...Array(totalPages)].map((_, index) => (
                        <button
                          key={index}
                          className={`pagination-page ${
                            currentPage === index + 1 ? "active" : ""
                          }`}
                          onClick={() => handlePageChange(index + 1)}
                        >
                          {index + 1}
                        </button>
                      ))}

                      <button
                        className="pagination-arrow"
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      >
                        →
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <p className="no-data">
                  There is no blocked amount on this wallet
                </p>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <div className="wallet-actions">
            <button
              className="wallet-btn debit"
              onClick={() => {
                setDebitModal(true);
                setShowWalletModal(false);
              }}
            >
              Debit amount
            </button>
            <button
              className="wallet-btn refund"
              onClick={() => {
                setRefundModal(true);
                setShowWalletModal(false);
              }}
            >
              Refund amount
            </button>
          </div>
        </DialogActions>
      </Dialog>
      {debitModal && (
        <div className="debit-overlay">
          <div className="debit-content">
            <button
              className="debit-close-btn"
              onClick={() => {
                setDebitModal(false);
                setSuccess(false);
                resetForm();
              }}
            >
              &times;
            </button>

            {success ? (
              <div className="success-wrapper">
                <div className="success-icon">
                  <img src={checkIcon} alt="Success" className="check-icon" />
                </div>
                <h2 className="success-title">Confirmed!</h2>
                <p className="success-subtitle">
                  Amount is successfully deducted from the wallet
                </p>
                <button
                  className="success-btn"
                  onClick={() => {
                    setDebitModal(false);
                    setSuccess(false);
                  }}
                >
                  Done
                </button>
              </div>
            ) : (
              <>
                <div className="debit-header">
                  <h2>Debit amount</h2>
                </div>

                <form
                  className="debit-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    setConfirmType("debit");
                    setShowConfirm(true);
                  }}
                >
                  <div className="debit-row">
                    <div className="debit-group">
                      <label>Wallet ID</label>
                      <input type="text" value={walletId} disabled />
                    </div>

                    <div className="debit-group">
                      <label>
                        Amount <span className="required">*</span>
                      </label>
                      <input
                        type="number"
                        step="0.01"
                        placeholder="Type here"
                        required
                        value={amount}
                        onChange={(e) => {
                          let value = e.target.value;

                          value = value.replace(/[^0-9.]/g, "");

                          const [before, after] = value.split(".");

                          const totalDigits =
                            (before || "").length + (after || "").length;

                          if (totalDigits <= 8) {
                            setAmount(parseFloat(value));
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div
                    className="debit-row"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <div className="debit-group" style={{ flex: 1 }}>
                      <label>Service category</label>
                      <select
                        value={serviceCategory}
                        onChange={(e) => setServiceCategory(e.target.value)}
                      >
                        <option value="">Select category</option>
                        {categoryData
                          ?.filter(
                            (item) =>
                              !item.isService &&
                              item.cashless?.sublimit?.enabled,
                          )
                          .map((item) => (
                            <option
                              key={item.categoryId}
                              value={item.categoryId}
                            >
                              {item.name}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div
                      style={{
                        whiteSpace: "nowrap",
                        fontSize: "14px",
                        color: "#666",
                      }}
                    >
                      or
                    </div>

                    <div className="debit-group" style={{ flex: 1 }}>
                      <label>Service ID</label>
                      <select
                        value={serviceId}
                        onChange={(e) => setServiceId(e.target.value)}
                      >
                        <option value="">Select service ID</option>
                        {categoryData
                          ?.filter((category) => category.isService)
                          .flatMap((category) =>
                            category.serviceIds?.map((id) => (
                              <option key={id} value={id}>
                                {id}
                              </option>
                            )),
                          )}
                      </select>
                    </div>
                  </div>

                  <div className="debit-group debit-full">
                    <label>
                      Add comment <span className="required">*</span>
                    </label>
                    <textarea
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      placeholder="Add a comment here..."
                      maxLength={250}
                      rows={4}
                    />
                    <span className="debit-char-limit">
                      {comment.length}/250 characters
                    </span>
                  </div>
                  <button
                    type="submit"
                    className="debit-continue-btn"
                    disabled={
                      !amount || !comment || (!serviceCategory && !serviceId)
                    }
                  >
                    Continue
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      )}

      {refundModal && (
        <div className="debit-overlay">
          <div className="debit-content">
            <button
              className="debit-close-btn"
              onClick={() => {
                setRefundModal(false);
                setSuccess(false);
                resetForm();
              }}
            >
              &times;
            </button>

            {success ? (
              <div className="success-wrapper">
                <div className="success-icon">
                  <img src={checkIcon} alt="Success" className="check-icon" />
                </div>
                <h2 className="success-title">Confirmed!</h2>
                <p className="success-subtitle">
                  Amount is successfully credited in the wallet
                </p>
                <button
                  className="success-btn"
                  onClick={() => {
                    setRefundModal(false);
                    setSuccess(false);
                  }}
                >
                  Done
                </button>
              </div>
            ) : (
              <>
                <div className="debit-header">
                  <h2>Refund amount</h2>
                </div>

                <form
                  className="debit-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    setConfirmType("refund");
                    setShowConfirm(true);
                  }}
                >
                  <div className="debit-row">
                    <div className="debit-group">
                      <label>Wallet ID</label>
                      <input type="text" value={walletId} disabled />
                    </div>

                    <div className="debit-group">
                      <label>
                        Amount <span className="required">*</span>
                      </label>
                      <input
                        type="number"
                        step="0.01"
                        placeholder="Type here"
                        required
                        value={amount}
                        onChange={(e) => {
                          let value = e.target.value;

                          value = value.replace(/[^0-9.]/g, "");

                          const [before, after] = value.split(".");

                          const totalDigits =
                            (before || "").length + (after || "").length;

                          if (totalDigits <= 8) {
                            setAmount(parseFloat(value));
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div
                    className="debit-row"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <div className="debit-group" style={{ flex: 1 }}>
                      <label>Service category</label>
                      <select
                        value={serviceCategory}
                        onChange={(e) => setServiceCategory(e.target.value)}
                      >
                        <option value="">Select category</option>
                        {categoryData
                          ?.filter(
                            (item) =>
                              !item.isService &&
                              item.cashless?.sublimit?.enabled,
                          )
                          .map((item) => (
                            <option
                              key={item.categoryId}
                              value={item.categoryId}
                            >
                              {item.name}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div
                      style={{
                        whiteSpace: "nowrap",
                        fontSize: "14px",
                        color: "#666",
                      }}
                    >
                      or
                    </div>

                    <div className="debit-group" style={{ flex: 1 }}>
                      <label>Service ID</label>
                      <select
                        value={serviceId}
                        onChange={(e) => setServiceId(e.target.value)}
                      >
                        <option value="">Select service ID</option>
                        {categoryData
                          ?.filter((category) => category.isService)
                          .flatMap((category) =>
                            category.serviceIds?.map((id) => (
                              <option key={id} value={id}>
                                {id}
                              </option>
                            )),
                          )}
                      </select>
                    </div>
                  </div>

                  <div className="debit-group debit-full">
                    <label>
                      Add comment <span className="required">*</span>
                    </label>
                    <textarea
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      placeholder="Add a comment here..."
                      maxLength={250}
                      rows={4}
                    />
                    <span className="debit-char-limit">
                      {comment.length}/250 characters
                    </span>
                  </div>

                  <button
                    type="submit"
                    className="debit-continue-btn"
                    disabled={
                      !amount || !comment || (!serviceCategory && !serviceId)
                    }
                  >
                    Continue
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      )}
      {showConfirm && (
        <div className="modal-overlay-confirm">
          <div className="modal-box-confirm">
            <h2>Are you sure?</h2>
            <p>
              {confirmType === "debit"
                ? "Once confirmed, the amount will be debited from the wallet. If you need to make any changes, please click 'Go back' to edit the details."
                : "Once confirmed, the amount will be credited into the wallet. If you need to make any changes, please click 'Go back' to edit the details."}
            </p>
            <div className="modal-actions-confirm">
              <button
                className="btn btn-secondary-confirm"
                onClick={() => setShowConfirm(false)}
              >
                Go back
              </button>
              <button
                className="btn btn-primary-confirm"
                onClick={() => {
                  setShowConfirm(false);
                  if (confirmType === "debit") {
                    processMoney(2); // Debit
                  } else {
                    processMoney(1); // Refund
                  }
                }}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AssignedPlansOnPid;
